var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container"},[(!_vm.imageSrc)?_c('v-skeleton-loader',{staticClass:"responsive",attrs:{"type":"image"}}):_vm._e(),_c('v-fade-transition',[(_vm.imageSrc)?_c('img',{staticClass:"responsive d-block",attrs:{"src":_vm.imageSrc,"alt":"PDF Preview"}}):_vm._e()]),_c('canvas',{ref:"canvas",staticStyle:{"display":"none"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }